<template>
  <div class="content">
    <p style="font-size: 18pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: center;">
      <span style="font-family: 宋体; font-size: 18pt; font-weight: bold;">“</span><span style="font-family: 宋体; font-size: 18pt; font-weight: bold;">无限鹤壁APP</span><span style="font-family: 宋体; font-size: 18pt; font-weight: bold;">”</span
      ><span style="font-family: 宋体; font-size: 18pt; font-weight: bold;">隐私政策</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="font-family: 宋体; font-size: 12pt;">&#xa0;</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: right;">
      <span style="font-family: 宋体; font-size: 12pt;">发布日期：202</span><span style="font-family: 宋体; font-size: 12pt;">3</span><span style="font-family: 宋体; font-size: 12pt;">年 </span><span style="font-family: 宋体; font-size: 12pt;">05</span
      ><span style="font-family: 宋体; font-size: 12pt;">月 </span><span style="font-family: 宋体; font-size: 12pt;">10</span><span style="font-family: 宋体; font-size: 12pt;">日</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: right;">
      <span style="font-family: 宋体; font-size: 12pt;">生效日期：202</span><span style="font-family: 宋体; font-size: 12pt;">3</span><span style="font-family: 宋体; font-size: 12pt;">年 </span><span style="font-family: 宋体; font-size: 12pt;">05</span
      ><span style="font-family: 宋体; font-size: 12pt;">月 </span><span style="font-family: 宋体; font-size: 12pt;">10</span><span style="font-family: 宋体; font-size: 12pt;">日</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">提示条款：</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">“</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">无限鹤壁</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">”服务提供者</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（</span><span style="font-family: 宋体; font-size: 12pt;">鹤壁市融媒体中心（鹤壁市广播电视台）</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">）</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（或简称“我们”）</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">深知个人信息对您的重要性，您的信任对我们非常重要</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">，</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。鉴于此，</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">我们</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">制定本《隐私权政策》（下称“本政策/本隐私权政策”）并提醒您：</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">本政策适用于“</span><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">无限鹤壁</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">”提供的所有产品和服务，包括但不限于电脑端、移动智能终端等的应用程序、网页、供第三方网站和应用程序使用的软件开发工具包（SDK）和应用程序编程接口（API）</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">以及不断创新研发的产品及服务。如您使用“</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">无限鹤壁</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">”提供的某项或某几项服务有其单独的隐私权政策的，该等服务对应的隐私权政策将与本隐私权政策一起构成一套完整的隐私权政策。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;"
        >需要特别说明的是，本政策不适用于其他第三方向您提供的服务，为确保流畅的产品体验，您可能会收到来自第三方提供的内容或网络链接。请您谨慎选择是否访问第三方提供的链接、内容、产品和服务。在向第三方提交个人信息之前，请认真阅读这些第三方的隐私政策。</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">如您未满18周岁，请您在监护人陪同下仔细阅读并充分理解本隐私政策，并征得监护人的同意后使用我们的服务或向我们提供信息。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">在使用我们各项产品或服务前，请您务必仔细阅读并透彻理解本政策。特别是以粗体/粗体下划线标识的条款，请您重点阅读，在确认充分理解并同意后再开始使用。</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">&#xa0;</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">如对本政策内容有任何疑问、意见或建议，您可通过“</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">无限鹤壁</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">”提供的各种联系方式与我们联系。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">第一部分 定义</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">“</span><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">无限鹤壁</span><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">”：</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">指“</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">无限鹤壁</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">”平台，包括但不限于电脑端（域名为</span
      ><a style="color: #191f25;" href="http://www.hebitv.com/" target="http://pha.chinacici.com/w/rongmei-related/environment/wxhebi/_blank"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">www.hebitv.com</span></a
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">）和手机APP端。开发主体为：</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">苏州世纪飞越网络信息有限公司</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">“</span><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">无限鹤壁</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">”服务提供者：</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">指提供“</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">无限鹤壁</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">”平台产品和服务的法人主体，即</span><span style="font-family: 宋体; font-size: 12pt;">鹤壁市融媒体中心（鹤壁市广播电视台）</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">儿童：</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">指不满十四周岁的未成年人。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">个人信息：</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">个人敏感信息：</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">指包括身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、儿童信息等的个人私密信息（我们将在本隐私权政策中对具体个人敏感信息以</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">粗体</span><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">或粗体下划线</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">进行显著标识）。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">个人信息删除：</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">第二部分 隐私权政策</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">本隐私权政策部分将帮助您了解以下内容：</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">一、我们如何收集和使用您的个人信息</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">二、我们如何使用Cookie和同类技术</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">三、我们如何共享、转让、公开披露您的个人信息</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">四、我们如何保护您的个人信息</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">五、您如何管理您的个人信息</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">六、对第三方的责任声明</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">七、我们如何处理儿童的个人信息</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">八、您的个人信息如何在全球范围转移</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">九、本隐私权政策如何更新</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">十、如何联系我们</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">一、我们如何收集和使用您的个人信息</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">您理解并同意：</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;"
        >1、我们致力于打造多样的产品和服务以满足您的需求。因我们向您提供的产品和服务种类众多，且不同用户选择使用的具体产品/服务范围存在差异，相应地，各类功能及收集使用的个人信息类型、范围等会有所区别，请以具体的产品/服务功能为准；</span
      >
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;"
        >2、为给您带来更好的产品和服务体验，我们在持续努力改进我们的技术，随之我们可能会不时推出新的或优化后的功能，可能需要收集、使用新的个人信息或变更个人信息使用目的或方式。对此，我们将通过更新本政策、弹窗、页面提示等方式另行向您说明对应信息的收集目的、范围及使用方式，并为您提供自主选择同意的方式，且在征得您明示同意后收集、使用</span
      ><span style="font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">相关信息。</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">在此过程中，如果您有任何疑问、意见或建议的，您可通过第十条“如何联系我们”中提供的各种联系方式与我们联系，我们会尽快为您作出解答。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（一）帮助您成为我们的用户</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">1、注册服务</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">为帮助您成为我们的用户，以便我们为您提供用户服务。您需要提供</span><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">手机号码创建账号设置密码</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（或验证码）和昵称以成为我们的注册用户。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">2、信息完善</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">您可以选择进一步完善本产品账号信息，如填写性别等信息，但如果您不提供这些信息，也不会影响您使用本产品提供的基础服务。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">（二）为您提供浏览服务</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">在您使用我们服务过程中，为识别账号异常状态、了解产品适配性、向您提供更契合您需求的内容展示和搜索结果， 同时基于文件缓存、下载，日志存储等基础运营需求，我们需要获得</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">您的公共区域读写权限，并可能会自动收集您的使用情况并存储为网络日志信息，包括：</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">设备信息：我们会根据您在软件安装及/或使用中的具体操作，接收并记录您所使用的设备相关信息（包括设备型号、操作系统版本、设备设置、唯一设备标识符、设备环境等软硬件特征信息）、设备所在位置相关信息（包括您</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">授权的GPS位置</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">以及WLAN接入点、蓝牙和基站等传感器信息）。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">服务日志信息：当您使用我们提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存，包括</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">浏览、点击查看</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">、搜索查询、收藏、关注分享信息、发布信息，以及</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">IP地址</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">、浏览器类型、电信运营商、使用语言、访问日期和时间等。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">请注意，单独的设备信息、服务日志信息是无法识别特定自然人身份的信息。</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">我们将获取您手机的</span><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">摄像头</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">权限用以帮助您使用已登录的移动设备扫描网页二维码的形式登录网页端产品。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">为向您提供更便捷的服务，我们会获取您的</span><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">悬浮窗权限</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">，以保证您在浏览、使用的过程中不被其他操作行为所影响。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">此外，我们也会为了不断改进和优化上述的功能来使用您的上述信息。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">我们收集、使用的上述信息均进行了去标识化处理，数据分析仅对应特定的、无法直接关联您身份的编码，不会与您的真</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">实身份相关联。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">（三）为您提供信息发布和互动服务</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">1、内容上传与发布</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（1）</span><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">当您使用内容评论、回复等功能时，我们将收集您选择发布的信息内容，并展示您的昵称、头像、发布内容（图文、视音频等）。</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">我们将获取您手机的录音权限用以在社区内发布音频内容。我们将获取您手机的摄像头权限用以在社区内发布图片及视频内容。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（2）</span><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">&#xa0;</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;"
        >请注意，您公开发布的信息中可能会涉及您或他人的个人信息甚至个人敏感信息，如您发布时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。您公开发布的信息中涉及儿童个人信息的，需在发布前取得所涉及儿童的监护人授权。前述情形下儿童或监护人有权通过本政策第十条的途径联系我们，要求更正或删除涉及儿童个人信息的内容；对于拒不删除或迟延删除导致的侵权责任，由信息发布人承担。</span
      >
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">2、互动</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">您对感兴趣的内容等产生互动（进行收藏、点赞、评论或分享内容时）我们会收集您收藏的账号，并向您展示您关注账号发布内容。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（四）邀请您参加活动</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;"
        >为不断完善本产品的功能及用户体验，平台会针对即将推出的服务或功能发起问卷调查等活动，并通过页面展示、通知、站内信、站外推送、您向我们提供的有效联系方式等向您提供相关活动的消息。如果您参加相关活动，我们可能会通过活动界面收集您提交的职业、性别、政治面貌、学历等信息，以便更准确地为您提供服务。若您不参加相关活动，则无需提供前述信息。</span
      >
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（五）客服及问题解决</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">通过</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">意见反馈</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">等方式与我们联系：当您与我们联系时，我们将收集您提供的咨询内容以及您的联系方式</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">（账号、住址、邮箱、通信/通话记录和内容或您留下的其他联系方式）</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">（六）为您提供安全保障</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">为预防、发现、调查欺诈、危害账户安全或其他违反与我们协议的行为，或实现您访问的目的，</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">我们将收集您的网络信息、设备信息、手机型号、硬件信息和系统信息。</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;"
        >为更好地预防网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或我们相关协议规则的情况，我们可能使用或整合您的会员信息、设备信息、服务日志信息以及我们合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</span
      >
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;"
        >为了使您能够接收信息推送、在第三方平台分享信息、使用地图服务等必要功能用途，我们的应用中会嵌入授权合作伙伴的SDK或其他类似的应用程序。如您使用华为/小米/OPPO/VIVO手机时，华为/小米/OPPO/VIVO Push
        SDK需要读取您的设备识别号、联网相关信息，用于推送/下发通知栏消息；如您使用向微博、微信等第三方平台分享信息的功能，微博、微信等第三方平台会收集您的电话状态、联网相关信息。</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;"> </span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;"
        >我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。</span
      >
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify; text-indent: 0pt;"><span style="font-family: 宋体; font-size: 12pt; font-weight: bold;">（7）</span><span style="font-family: 宋体; font-size: 12pt; font-weight: bold;">第三方向我们提供的信息</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;"
        >为不断完善本产品的功能及用户体验，平台会针对即将推出的服务或功能发起问卷调查等活动，并通过页面展示、通知、站内信、站外推送、您向我们提供的有效联系方式等向您提供相关活动的消息。如果您参加相关活动，我们可能会通过活动界面收集您提交的职业、性别、政治面貌、学历等信息，以便更准确地为您提供服务。若您不参加相关活动，则无需提供前述信息。</span
      >
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; text-align: justify; widows: 0;">
      <span style="font-family: 宋体; font-size: 12pt;">用户因使用我们的产品或者服务而被我们收集的信息，例如其他用户发布的信息中可能含有你的部分信息（如：在评论、留言、发布图文、音视频中涉及到与你相关的信息），亦可能从客户端关联公司、合作第三方或通过其他合法途径获取的您的个人数据信息。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; text-align: justify; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">&#xa0;</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">第三方应用服务包含：</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">（</span><span style="font-family: 宋体; font-size: 12pt;">安卓版本</span><span style="font-family: 宋体; font-size: 12pt;">）</span></p>
    <div style="overflow-x: auto;">
      <table cellspacing="0" cellpadding="0" style="border-collapse: collapse; margin-left: 0pt; width: 524.55pt;">
        <tr>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 42.6pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">名称</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 43.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">使用目的</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 186.1pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">个人信息类型</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 41.7pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">数据是否去标识化传输</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 40.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">第三方机构名称</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 105.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">第三方隐私政策链接</span></p>
          </td>
        </tr>
        <tr>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 42.6pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">友盟SDK</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 43.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <span style="font-family: 宋体; font-size: 9pt;">数据统计分析、社会化分享</span><span style="font-family: 宋体; font-size: 9pt;">、</span><span style="font-family: 宋体; font-size: 9pt;">推送</span><span style="font-family: 宋体; font-size: 9pt;">、应用性能监测服务</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 186.1pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/IP地址/SIM 卡 IMSI 信息等）</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 41.7pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">是</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 40.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">北京锐讯灵通科技有限公司</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 105.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <a href="https://www.umeng.com/page/policy"><span style="color: #0000ff; font-family: 宋体; font-size: 9pt; text-decoration: underline; vertical-align: baseline;">https://www.umeng.com/page/policy</span></a>
            </p>
          </td>
        </tr>
        <tr>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 42.6pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">小米 push</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 43.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">小米厂商推送</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 186.1pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <span style="font-family: 宋体; font-size: 9pt; font-weight: normal;">小米厂商推送 </span><span style="font-family: 宋体; font-size: 9pt; font-weight: normal;">（</span
              ><span style="font-family: 宋体; font-size: 9pt; font-weight: normal;">AndroidID、设备存储信息、网络状态、设备信息</span><span style="font-family: 宋体; font-size: 9pt; font-weight: normal;">）</span>
            </p>
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">&#xa0;</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 41.7pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">是</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 40.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">小米科技有限责任公司</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 105.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <a href="https://dev.mi.com/console/doc/detail?pId=1822"><span style="color: #0000ff; font-family: 宋体; font-size: 9pt; text-decoration: underline;">https://dev.mi.com/console/doc/detail?pId=1822</span></a>
            </p>
          </td>
        </tr>
        <tr>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 42.6pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">华为push</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 43.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">华为push</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 186.1pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <span style="font-family: 宋体; font-size: 9pt; font-weight: normal; vertical-align: baseline;">华为push</span><span style="font-family: 宋体; font-size: 9pt; font-weight: normal; vertical-align: baseline;">（设备存储信息、网络状态）</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 41.7pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">是</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 40.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">华为技术有限公司</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 105.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <a href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides-V5/privacy-statement-0000001050042021-V5"
                ><span style="color: #0000ff; font-family: 宋体; font-size: 9pt; text-decoration: underline;">https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides-V5/privacy-statement-0000001050042021-V5</span></a
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 42.6pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">oppo push</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 43.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">OPPO厂商推送</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 186.1pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; font-weight: normal; vertical-align: baseline;">手机设备信息</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 41.7pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">是</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 40.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">OPPO广东移动通信有限公司</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 105.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <a style="color: #0052cc;" href="https://open.oppomobile.com/wiki/doc#id=10288"
                ><span style="background-color: #ffffff; color: #0052cc; font-family: 宋体; font-size: 9pt; font-style: normal; text-decoration: underline; text-transform: none;">https://open.oppomobile.com/wiki/doc#id=10288</span></a
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 42.6pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">vivo push</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 43.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">VIVO厂商推送</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 186.1pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; font-weight: normal; vertical-align: baseline;">手机设备信息</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 41.7pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">是</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 40.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">维沃移动通信有限公司</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 105.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <a href="https://www.vivo.com.cn/about-vivo/privacy-policy"><span style="color: #0000ff; font-family: 宋体; font-size: 9pt; text-decoration: underline;">https://www.vivo.com.cn/about-vivo/privacy-policy</span></a>
            </p>
          </td>
        </tr>
        <tr>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 42.6pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">新浪微博</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 43.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">实现新浪微博分享/登录服务</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 186.1pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">个人常用设备信息</span><span style="font-family: 宋体; font-size: 9pt;">（手机设备信息、位置信息、应用列表、网络状态）</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 41.7pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">是</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 40.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">北京新浪互联信息服务有限公司</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 105.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <a href="https://www.weibo.com/signup/v5/privacy"><span style="color: #0000ff; font-family: 宋体; font-size: 9pt; text-decoration: underline;">https://www.weibo.com/signup/v5/privacy</span></a>
            </p>
          </td>
        </tr>
        <tr>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 42.6pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">淘宝Agoo推送</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 43.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">淘宝开放平台技术服务</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 186.1pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">手机设备信息</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 41.7pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">是</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 40.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">阿里巴巴（中国）网络技术有限公司</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 105.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <a href="https://terms.alicdn.com/legal-agreement/terms/suit_bu1_taobao/suit_bu1_taobao201703241622_61002.html?spm=a2145.7268393.0.0.f9aa5d7ccvMkrK"
                ><span style="color: #0000ff; font-family: 宋体; font-size: 9pt; text-decoration: underline;">https://terms.alicdn.com/legal-agreement/terms/suit_bu1_taobao/suit_bu1_taobao201703241622_61002.html?spm=a2145.7268393.0.0.f9aa5d7ccvMkrK</span></a
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 42.6pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">Mtop</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 43.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">数据统计分析</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 186.1pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">手机设备信息</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 41.7pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">是</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 40.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">阿里巴巴（中国）网络技术有限公司</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 105.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <a style="color: #800080;" href="https://terms.alicdn.com/legal-agreement/terms/suit_bu1_taobao/suit_bu1_taobao201703241622_61002.html?spm=a2145.7268393.0.0.f9aa5d7ccvMkrK"
                ><span style="color: #800080; font-family: 宋体; font-size: 9pt; text-decoration: underline;">https://terms.alicdn.com/legal-agreement/terms/suit_bu1_taobao/suit_bu1_taobao201703241622_61002.html?spm=a2145.7268393.0.0.f9aa5d7ccvMkrK</span></a
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 42.6pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">腾讯X5</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 43.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">优化移动端WebView体验</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 186.1pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">个人常用设备信息</span><span style="font-family: 宋体; font-size: 9pt;">（网络类型）</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 41.7pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">是</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 40.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">深圳市腾讯计算机系统有限公司</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 105.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <a href="https://x5.tencent.com/docs/index.html"><span style="color: #0000ff; font-family: 宋体; font-size: 9pt; text-decoration: underline;">https://x5.tencent.com/docs/index.html</span></a>
            </p>
          </td>
        </tr>
        <tr>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 42.6pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">QQSDK</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 43.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">QQ/QQ空间分享</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 186.1pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">个人常用设备信息</span><span style="font-family: 宋体; font-size: 9pt;">（手机设备信息、位置信息、应用列表、网络状态）</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 41.7pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">是</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 40.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">深圳市腾讯计算机系统有限公司</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 105.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <a style="color: #0052cc;" href="https://wiki.connect.qq.com/qq%E4%BA%92%E8%81%94sdk%E9%9A%90%E7%A7%81%E4%BF%9D%E6%8A%A4%E5%A3%B0%E6%98%8E"
                ><span style="background-color: #ffffff; color: #0052cc; font-family: 宋体; font-size: 9pt; font-style: normal; text-decoration: underline; text-transform: none;">https://wiki.connect.qq.com/qq%E4%BA%92%E8%81%94sdk%E9%9A%90%E7%A7%81%E4%BF%9D%E6%8A%A4%E5%A3%B0%E6%98%8E</span></a
              >
            </p>
          </td>
        </tr>
        <tr style="height: 20.05pt;">
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 42.6pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">微信SDK</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 43.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">微信登陆</span><span style="font-family: 宋体; font-size: 9pt;">/</span><span style="font-family: 宋体; font-size: 9pt;">分享</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 186.1pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">个人常用设备信息</span><span style="font-family: 宋体; font-size: 9pt;">（手机设备信息、位置信息、应用列表、网络状态）</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 41.7pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">是</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 40.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">深圳市腾讯计算机系统有限公司</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 105.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <a style="color: #0052cc;" href="https://www.wechat.com/zh_CN/privacy_policy.html"
                ><span style="background-color: #ffffff; color: #0052cc; font-family: 宋体; font-size: 9pt; font-style: normal; text-decoration: underline; text-transform: none;">https://www.wechat.com/zh_CN/privacy_policy.html</span></a
              >
            </p>
          </td>
        </tr>
      </table>
    </div>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">&#xa0;</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">(IOS版)</span></p>
    <div style="overflow-x: auto;">
      <table cellspacing="0" cellpadding="0" style="border-collapse: collapse; margin-left: 0pt; width: 523.35pt;">
        <tr>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 42pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">名称</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 43.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">使用目的</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 186.1pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">个人信息类型</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 41.7pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">数据是否去标识化传输</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 40.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">第三方机构名称</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 104.6pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">第三方隐私政策链接</span></p>
          </td>
        </tr>
        <tr>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 42pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">友盟SDK</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 43.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <span style="font-family: 宋体; font-size: 9pt;">数据统计分析、社会化分享</span><span style="font-family: 宋体; font-size: 9pt;">、</span><span style="font-family: 宋体; font-size: 9pt;">推送</span><span style="font-family: 宋体; font-size: 9pt;">、应用性能监测服务</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 186.1pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/IP地址/SIM 卡 IMSI 信息等）</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 41.7pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">是</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 40.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">北京锐讯灵通科技有限公司</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 104.6pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <a href="https://www.umeng.com/page/policy"><span style="color: #0000ff; font-family: 宋体; font-size: 9pt; text-decoration: underline; vertical-align: baseline;">https://www.umeng.com/page/policy</span></a>
            </p>
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">&#xa0;</span></p>
          </td>
        </tr>
        <tr>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 42pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">新浪微博</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 43.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">实现新浪微博分享/登录服务</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 186.1pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">个人常用设备信息</span><span style="font-family: 宋体; font-size: 9pt;">（手机设备信息、位置信息、应用列表、网络状态）</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 41.7pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">是</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 40.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">北京新浪互联信息服务有限公司</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 104.6pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <a href="https://www.weibo.com/signup/v5/privacy"><span style="color: #0000ff; font-family: 宋体; font-size: 9pt; text-decoration: underline;">https://www.weibo.com/signup/v5/privacy</span></a>
            </p>
          </td>
        </tr>
        <tr>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 42pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">QQSDK</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 43.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">QQ/QQ空间分享</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 186.1pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">个人常用设备信息</span><span style="font-family: 宋体; font-size: 9pt;">（手机设备信息、位置信息、应用列表、网络状态）</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 41.7pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">是</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 40.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">深圳市腾讯计算机系统有限公司</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 104.6pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <a style="color: #0052cc;" href="https://wiki.connect.qq.com/qq%E4%BA%92%E8%81%94sdk%E9%9A%90%E7%A7%81%E4%BF%9D%E6%8A%A4%E5%A3%B0%E6%98%8E"
                ><span style="background-color: #ffffff; color: #0052cc; font-family: 宋体; font-size: 9pt; font-style: normal; text-decoration: underline; text-transform: none;">https://wiki.connect.qq.com/qq%E4%BA%92%E8%81%94sdk%E9%9A%90%E7%A7%81%E4%BF%9D%E6%8A%A4%E5%A3%B0%E6%98%8E</span></a
              >
            </p>
          </td>
        </tr>
        <tr style="height: 20.05pt;">
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 42pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">微信SDK</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 43.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">微信登陆</span><span style="font-family: 宋体; font-size: 9pt;">/</span><span style="font-family: 宋体; font-size: 9pt;">分享</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 186.1pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">个人常用设备信息</span><span style="font-family: 宋体; font-size: 9pt;">（手机设备信息、位置信息、应用列表、网络状态）</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 41.7pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">是</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 40.2pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt; vertical-align: baseline;">深圳市腾讯计算机系统有限公司</span></p>
          </td>
          <td
            style="
              border-bottom-color: #000000;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #000000;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #000000;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #000000;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding-left: 5.03pt;
              padding-right: 5.03pt;
              vertical-align: top;
              width: 104.6pt;
            "
          >
            <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
              <a style="color: #0052cc;" href="https://www.wechat.com/zh_CN/privacy_policy.html"
                ><span style="background-color: #ffffff; color: #0052cc; font-family: 宋体; font-size: 9pt; font-style: normal; text-decoration: underline; text-transform: none;">https://www.wechat.com/zh_CN/privacy_policy.html</span></a
              >
            </p>
          </td>
        </tr>
      </table>
    </div>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 12pt; font-weight: bold;">&#xa0;</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 12pt; font-weight: bold;">友盟+ SDK服务</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">个人信息类字段采集情况：</span></p>
    <table cellspacing="0" cellpadding="0" style="border-collapse: collapse; margin-left: 0pt;">
      <tr>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 82.15pt;
          "
        >
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">SDK类型</span></p>
        </td>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 157.05pt;
          "
        >
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">SDK个人信息字段</span></p>
        </td>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 71.7pt;
          "
        >
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">用途</span></p>
        </td>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 71.7pt;
          "
        >
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">数据保护方式</span></p>
        </td>
      </tr>
      <tr>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 82.15pt;
          "
        >
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">U-App 统计分析服务</span></p>
        </td>
        <td
          rowspan="4"
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 157.05pt;
          "
        >
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">&#xa0;</span></p>
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">&#xa0;</span></p>
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">获取设备序列号及粗略位置:</span></p>
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM卡IMSI/IP</span></p>
        </td>
        <td
          rowspan="4"
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 71.7pt;
          "
        >
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">1、基于设备提供 SDK 服务2、基于 IP 提供地区数据报表</span></p>
        </td>
        <td
          rowspan="4"
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 71.7pt;
          "
        >
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">1、采用 SSL 协议加密及HTTPS 传输加密技术保障安全</span></p>
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">2、采取加密、去标识化等安全措施脱敏处理</span></p>
        </td>
      </tr>
      <tr>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 82.15pt;
          "
        >
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">U-Push 消息推送服务</span></p>
        </td>
      </tr>
      <tr>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 82.15pt;
          "
        >
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">U-Share 社会化分享服务</span></p>
        </td>
      </tr>
      <tr>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 82.15pt;
          "
        >
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">U-APM 应用性能检测服务</span></p>
        </td>
      </tr>
    </table>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">&#xa0;</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">&#xa0;</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">个人信息类权限使用情况</span></p>
    <table cellspacing="0" cellpadding="0" style="border-collapse: collapse; margin-left: 0pt;">
      <tr>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 35.25pt;
          "
        >
          <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">序号</span></p>
        </td>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 144.45pt;
          "
        >
          <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">权限名称</span></p>
        </td>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 113.85pt;
          "
        >
          <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">涉及产品</span></p>
        </td>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 89.05pt;
          "
        >
          <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">功能描述</span></p>
        </td>
      </tr>
      <tr>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 35.25pt;
          "
        >
          <p style="font-size: 10.5pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 10.5pt;">1</span></p>
        </td>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 144.45pt;
          "
        >
          <p style="font-size: 10.5pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
            <span style="font-family: 宋体; font-size: 10.5pt;">READ</span><span style="font-family: 宋体; font-size: 10.5pt;">_</span><span style="font-family: 宋体; font-size: 10.5pt;">PHONE</span><span style="font-family: 宋体; font-size: 10.5pt;">_</span
            ><span style="font-family: 宋体; font-size: 10.5pt;">STATE</span>
          </p>
        </td>
        <td
          rowspan="3"
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 113.85pt;
          "
        >
          <p style="font-size: 10.5pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 10.5pt;">U-APP 统计分析服务U-Push 消息推送服务</span></p>
          <p style="font-size: 10.5pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 10.5pt;">U-Share 社会化分享</span></p>
        </td>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 89.05pt;
          "
        >
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
            <span style="font-family: 宋体; font-size: 9pt;">获取用户设备的 IMEI，通过 IMEI 对用户进行唯</span><span style="font-family: 宋体; font-size: 9pt;">一</span><span style="font-family: 宋体; font-size: 9pt;">标识，以便提供服务。</span>
          </p>
        </td>
      </tr>
      <tr>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 35.25pt;
          "
        >
          <p style="font-size: 10.5pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 10.5pt;">2</span></p>
        </td>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 144.45pt;
          "
        >
          <p style="font-size: 10.5pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
            <span style="font-family: 宋体; font-size: 10.5pt;">ACCESS</span><span style="font-family: 宋体; font-size: 10.5pt;">_</span><span style="font-family: 宋体; font-size: 10.5pt;">COARSE</span><span style="font-family: 宋体; font-size: 10.5pt;">_</span
            ><span style="font-family: 宋体; font-size: 10.5pt;">LOCATION</span>
          </p>
        </td>
        <td
          rowspan="2"
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 89.05pt;
          "
        >
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">通过获取位置信息，为开发者提供反舞弊功能剔除作整设备:同时校正用户的地域分布数据使报表数据更加准确。本权限为可选权限。</span></p>
        </td>
      </tr>
      <tr>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 35.25pt;
          "
        >
          <p style="font-size: 10.5pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 10.5pt;">3</span></p>
        </td>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 144.45pt;
          "
        >
          <p style="font-size: 10.5pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
            <span style="font-family: 宋体; font-size: 10.5pt;">ACCESS</span><span style="font-family: 宋体; font-size: 10.5pt;">_</span><span style="font-family: 宋体; font-size: 10.5pt;">FINE</span><span style="font-family: 宋体; font-size: 10.5pt;">_</span
            ><span style="font-family: 宋体; font-size: 10.5pt;">LOCATION</span>
          </p>
        </td>
      </tr>
      <tr>
        <td
          rowspan="2"
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 35.25pt;
          "
        >
          <p style="font-size: 10.5pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 10.5pt;">4</span></p>
        </td>
        <td
          rowspan="2"
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 144.45pt;
          "
        >
          <p style="font-size: 10.5pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
            <span style="font-family: 宋体; font-size: 10.5pt;">WRITE</span><span style="font-family: 宋体; font-size: 10.5pt;">_</span><span style="font-family: 宋体; font-size: 10.5pt;">EXTERNAL</span><span style="font-family: 宋体; font-size: 10.5pt;">_</span
            ><span style="font-family: 宋体; font-size: 10.5pt;">STORAGE</span>
          </p>
        </td>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 113.85pt;
          "
        >
          <p style="font-size: 10.5pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 10.5pt;">U-Push 消息推送服务</span></p>
        </td>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 89.05pt;
          "
        >
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">用来保存设备相关信息，以确保设备唯一标识的准确性，以便精准向目标设备推送消息。</span></p>
        </td>
      </tr>
      <tr>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 113.85pt;
          "
        >
          <p style="font-size: 10.5pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 10.5pt;">U-Share 社会化分享</span></p>
        </td>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 89.05pt;
          "
        >
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">在不同 App 间分享大图/多图或大文件时使用。</span></p>
        </td>
      </tr>
      <tr>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 35.25pt;
          "
        >
          <p style="font-size: 10.5pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 10.5pt;">5</span></p>
        </td>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 144.45pt;
          "
        >
          <p style="font-size: 10.5pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;">
            <span style="font-family: 宋体; font-size: 10.5pt;">READ</span><span style="font-family: 宋体; font-size: 10.5pt;">_</span><span style="font-family: 宋体; font-size: 10.5pt;">EXTERNAL</span><span style="font-family: 宋体; font-size: 10.5pt;">_</span
            ><span style="font-family: 宋体; font-size: 10.5pt;">STORAGE</span>
          </p>
        </td>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 113.85pt;
          "
        >
          <p style="font-size: 10.5pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 10.5pt;">U-Share 社会化分享</span></p>
        </td>
        <td
          style="
            border-bottom-color: #000000;
            border-bottom-style: solid;
            border-bottom-width: 0.75pt;
            border-left-color: #000000;
            border-left-style: solid;
            border-left-width: 0.75pt;
            border-right-color: #000000;
            border-right-style: solid;
            border-right-width: 0.75pt;
            border-top-color: #000000;
            border-top-style: solid;
            border-top-width: 0.75pt;
            padding-left: 5.03pt;
            padding-right: 5.03pt;
            vertical-align: top;
            width: 89.05pt;
          "
        >
          <p style="font-size: 9pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 9pt;">在不同 App 间分享大图/多图或大文件时使用。</span></p>
        </td>
      </tr>
    </table>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">&#xa0;</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">（八）其他</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">1、若您提供的信息中含有其他用户的个人信息，在向我们提供这些个人信息之前，您需确保您已经取得合法的授权。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">2、若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;"
        >若我们从第三方处间接获取您的信息的，我们会在收集前明确以书面形式要求该第三方在已依法取得您同意后收集个人信息，并向您告知共享的信息内容，且涉及敏感信息的在提供给我们使用前需经过您的明确确认，要求第三方对个人信息来源的合法性和合规性作出承诺，如第三方有违反行为的，我们会明确要求对方承担相应法律责任；同时，我们的专业安全团队对个人信息会进行安全加固（包括敏感信息报备、敏感信息加密存储、访问权限控制等）。我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。</span
      >
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">3、征得授权同意的例外</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">您充分理解并同意，我们在以下情况下收集、使用您的个人信息无需您的授权同意，且我们可能不会响应您提出的更正/修改、删除、注销、撤回同意、索取信息的请求：</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（1）与国家安全、国防安全有关的；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（2）与公共安全、公共卫生、重大公共利益有关的；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（3）与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（5）您自行向社会公众公开的个人信息；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（7）根据与您签订和履行相关协议或其他书面文件所必需的；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（8）用于维护所提供的产品及/或服务的安全稳定运行所必需的，例如发现、处置产品及/或服务的故障；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（9）为合法的新闻报道所必需的；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（11）法律法规规定的其他情形。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">请知悉，根据适用的法律，若我们</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">，或我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善我们的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务（包括使用匿名数据进行机器学习或模型算法训练），</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">则此类处理后数据的使用无需另行向您通知并征得您的同意。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">4、如我们停止运营我们的产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对我们所持有的与已关停业务相关的个人信息进行删除或匿名化处理。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">二、我们如何使用 Cookie 和同类技术</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">（一）Cookie</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">为确保“</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">无限鹤壁</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">”平台正常运转、为您获得更轻松的访问体验，我们会在您的计算机或移动设备上存储Cookie、Flash Cookie，或浏览器（或关联应用程序）提供的其他通常包含标识符、站点名称以及一些号码和字符的本地存储（统称“Cookie”）。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">如果您的附加服务允许，您可修改对Cookie的接受程度或拒绝我们的Cookie。</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;"
        >有关详情，请参见 AboutCookies.org。但如果您这么做，您将可能无法享受更佳的服务体验，甚至在某些情况下可能会影响您安全访问我们的网站，且可能需要在每一次访问我们的平台时更改用户设置；因您的个人修改导致个人数据泄漏或相关其他用户数据泄漏的，由您承担全部法律责任。</span
      >
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">（二）Cookie同类技术</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">除 Cookie外，我们还会使用网站信标、像素标签、ETag等其他同类技术。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;"
        >例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。</span
      >
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;"
        >ETag（实体标签）是在互联网浏览器与互联网服务器之间背后传送的HTTP协议标头，可代替Cookie。ETag可以帮助我们避免不必要的服务器负载，提高服务效率，节省资源、能源，同时，我们可能通过ETag来记录您的身份，以便我们可以更深入地了解和改善我们的产品或服务。</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">但请注意，如果停用ETag，您可能无法享受相对更佳的产品或服务体验；由此造成的个人数据丢失，由个人承担不利后果。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">三、我们如何共享、转让、公开披露您的个人信息</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">（一）共享</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">我们不会与“</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">无限鹤壁</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">”服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">1、</span><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">在法定情形下的共享：</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">我们可能会根据法律法规规定、诉讼、争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">2、</span><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">在获取明确同意的情况下共享：</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">获得您的明确同意后，我们会与其他方共享您的个人信息。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">3、</span><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">与授权合作伙伴共享：我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">我们仅会出于本隐私权政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到其履行职责所需信息，且不得将此信息用于其他任何目的。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">目前，我们的授权合作伙伴包括以下类型：</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（1）</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">内容分析服务类的授权合作伙伴。</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">“</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">无限鹤壁</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">”中的内容可能由我们的合作方，或者我们与软件服务提供商、智能设备提供商、系统服务提供商（以下或称“服务提供方”）联合向您提供。除非得到您的许可，否则我们不会将您的个人身份信息与提供内容、分析服务的合作伙伴共享。</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">我们会委托这些合作伙伴处理与内容覆盖面和有效性相关的信息，但不会提供您的个人身份信息，我们会将去标识化后的个人信息与这些服务提供方等进行共享，而不会识别到您个人。</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的内容服务或决策建议。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（2）</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">供应商、服务提供商和其他合作伙伴。</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括受我们委托提供的技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;"
        >我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。</span
      >
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（二）转让</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">我们不会将您的个人信息转让给任何公司、组织和个人，</span><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">但以下情况除外：</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;"
        >（2）在本产品服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</span
      >
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（三）公开披露</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">我们仅会在以下情况下，公开披露您的个人信息：</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（1）获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;"
        >（2）如果我们确定您出现违反法律法规或严重违反本产品相关协议规则的情况，或为保护本产品及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或本产品相关协议规则披露关于您的个人信息，包括相关违规行为以及本产品已对您采取的措施。</span
      >
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">1、与国家安全、国防安全有关的；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">2、与公共安全、公共卫生、重大公共利益有关的；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">3、与犯罪侦查、起诉、审判和判决执行等有关的；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">5、您自行向社会公众公开的个人信息；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">四、我们如何保护您的个人信息安全</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;"
        >（一）我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的客户端与服务器之间交换数据时受SSL协议加密保护；我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</span
      >
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（二）我们有行业先进的以数据为核心、围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（三）我们会采取合理可行的措施，尽力避免收集无关的个人信息。</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求。而我们判断前述期限的标准包括：</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">1、保证我们为您提供服务的安全和质量；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">2、您是否同意更长的留存期间；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">3、是否存在保留期限的其他特别约定。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（四）互联网并非绝对安全的环境，在使用“</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">无限鹤壁</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">”的服务时：</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果由于我们的原因，导致“</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">无限鹤壁</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;"
        >”物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将依法承担相应责任；非因我方原因造成您个人数据的泄漏、篡改或毁坏等，导致您的合法权益受损，由相关责任方承担法律责任。</span
      >
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（五）我们将不定期更新并公开安全风险、个人信息安全影响评估报告等有关内容，您可通过我们的公告方式获得。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;"
        >（六）在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</span
      >
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">五、您如何管理您的个人信息</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">您可以通过以下方式访问及管理您的个人信息：</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">（一）访问您的个人信息</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">1、您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息：</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">账户信息——如果您希望访问或编辑您的账户中的个人基本资料信息，您可以通过登录您的账号执行此类操作。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">清除数据——您可以通过点击系统设置后，在“清除缓存”中清除缓存等。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">2、如果您无法通过上述路径访问您的个人信息，您可以随时通过“</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">无限鹤壁</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">”提供的</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">意见反馈入口</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">与我们取得联系。我们将在15天内回复您的访问请求。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">3、对于您在使用我们的产品或服务过程中产生的其他个人信息，我们将根据“（七）响应您的上述请求”向您提供相关安排。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（二）更正或补充您的个人信息</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正或补充。您可以通过“（一）访问您的个人信息”中列明的方式提出更正或补充申请。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">（三）删除您的个人信息</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">1、您可以通过“（一）访问您的个人信息”中列明的方式删除您的部分个人信息。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">2、在以下情形中，您可以向我们提出删除个人信息的请求：</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（1）如果我们处理个人信息的行为违反法律法规；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（2）如果我们收集、使用您的个人信息，却未征得您的明确同意；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（3）如果我们处理个人信息的行为严重违反了与您的约定；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（4）如果您不再使用我们的产品或服务，或您主动注销了账号；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（5）如果我们永久不再为您提供产品或服务。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">3、若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">4、当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">（四）改变您授权同意的范围</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">每个业务功能需要一些基本的个人信息才能得以完成（见本隐私权政策“第二部分”）。除此之外，您可以通过解除绑定、修改个人设置、删除相关信息等方式撤回部分授权，也可以通过关闭功能的方式撤销部分授权。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">当您收回同意后，我们将不再处理相应的个人信息。</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（五）个人信息主体注销账户</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">1、您可以自行在“账号安全”页面提交账户注销申请。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">2、在您主动注销账户之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（六）约束信息系统自动决策</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害本产品商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（七）响应您的上述请求</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">1、为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">2、我们将在15天内做出答复。如您不满意，还可以通过本隐私政策第十条载明的客服联系方式发起投诉。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">3、</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">&#xa0;</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;"
        >对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</span
      >
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">4、在以下情形中，按照法律法规要求，我们将无法响应您的请求：</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（1）与国家安全、国防安全有关的；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（2）与公共安全、公共卫生、重大公共利益有关的；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（3）与犯罪侦查、起诉、审判和执行判决等有关的；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（4）有充分证据表明个人信息主体存在主观恶意或滥用权利的；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（6）涉及商业秘密的。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">六、对第三方的责任声明</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">当您访问“</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">无限鹤壁</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">”接入的第三方服务或程序（例如：关注第三方注册的公众账号、接受第三方通过公众账号提供的服务及产品）时，第三方会根据自己的隐私权政策或其他协议</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">收集、使用、存储您的相关数据或信息</span
      ><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">。这些第三方程序可能会放置他们自己的Cookie或网络Beacon,这些Cookie或网络Beacon不受我们控制，且它们的使用不受本隐私政策的约束。我们会努力要求这些主体对您个人信息采取保护措施，建议</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">您在接受或使用第三方产品前应充分了解其服务条款及隐私权政策。如果您发现有第三方产品或服务提供者存在违法违规行为，建议您终止相关操作。同时，您可以向“</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">无限鹤壁</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">”反馈，我们将在查实后予以处理。如您不使用上述第三方产品或服务，则无需提供上述信息。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">七、我们如何处理儿童的个人信息</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">如果没有监护人的同意，儿童不得创建自己的用户账户。如您为儿童，我们要求您请您的监护人仔细阅读本隐私权政策，并在征得您的监护人同意的前提下使用我们的服务或向我们提供信息。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">对于经监护人同意使用我们的产品或服务而收集儿童个人信息的情况，我们只会在法律法规允许、监护人明确同意或者保护儿童所必要的情况下使用、共享、转让或披露此信息。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">八、您的个人信息如何在全球范围转移</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">1、法律法规有明确规定；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">2、获得您的明确授权。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护。存在出境情况的，将按照国家有关规定进行出境安全评估。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">九、本隐私权政策如何更新</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">我们的隐私权政策可能变更，除法律法规或监管规定另有强制性规定外，经调整或变更的内容一经通知或公布后的7日后生效。如您在隐私权政策调整或变更后继续使用“</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">无限鹤壁</span
      ><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">”提供的任一服务或访问相关网站或相关应用程序的，我们相信这代表您已充分阅读、理解并接受修改后的隐私权政策并受其约束。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;">
      <span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">1、未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。我们会在专门页面上发布对隐私权政策所做的任何变更。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">2、对于重大变更，我们还会提供更为显著的通知（例如：向您提供弹窗提示）。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold; text-decoration: underline;">本政策所指的重大变更包括但不限于：</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（2）我们在控制权等方面发生重大变化。如并购重组等引起的所有者变更等；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（3）个人信息共享、转让或公开披露的主要对象发生变化；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;"><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">（6）个人信息安全影响评估报告表明存在高风险。</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; text-align: justify;"><span style="color: #0d0013; font-family: 宋体; font-size: 12pt; font-weight: bold;">十、如何联系我们</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; text-align: justify; widows: 0;">
      <span style="font-family: 宋体; font-size: 12pt;">1、如对本政策内容有任何疑问、意见或建议，您都可以</span><span style="font-family: 宋体; font-size: 12pt;">将问题</span><span style="font-family: 宋体; font-size: 12pt;">发送至我们的个人信息保护邮箱</span
      ><span style="font-family: 宋体; font-size: 12pt;">(wuxianhebi@163.com)，</span><span style="font-family: 宋体; font-size: 12pt;">我们的通信方式：</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; text-align: justify; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">&#xa0;</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; text-align: justify; widows: 0;">
      <span style="font-family: 宋体; font-size: 12pt;">➢ 收件人：</span><span style="font-family: 宋体; font-size: 12pt;">鹤壁</span><span style="font-family: 宋体; font-size: 12pt;">市广播电视台</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; text-align: justify; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">&#xa0;</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; text-align: justify; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">➢ </span><span style="font-family: 宋体; font-size: 12pt;">地址：河南省鹤壁市淇滨区黄河路163号</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; text-align: justify; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">&#xa0;</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; text-align: justify; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">➢ 邮编：</span><span style="font-family: 宋体; font-size: 12pt;">458030</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; text-align: justify; widows: 0;"><span style="font-family: 宋体; font-size: 12pt;">&#xa0;</span></p>
    <p style="font-size: 12pt; line-height: 115%; margin: 0pt 0pt 10pt; orphans: 0; text-align: justify; widows: 0;">
      <span style="font-family: 宋体; font-size: 12pt;">2、如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。</span>
    </p>
    <p style="font-size: 12pt; line-height: 115%; margin: 5pt 0pt; text-align: justify;">
      <span style="color: #191f25; font-family: 宋体; font-size: 12pt;">本提示条款的最终解释权和解除权归</span><span style="font-family: 宋体; font-size: 12pt;">鹤壁市融媒体中心（鹤壁市广播电视台）</span><span style="color: #191f25; font-family: 宋体; font-size: 12pt;">。</span>
    </p>
  </div>
</template>
<script>
const PalauAPI = window.PalauAPI
export default {
  mounted() {
    if (typeof SZJSBridge !== 'undefined') {
      PalauAPI.view.showHeader()
      PalauAPI.view.toggleShareBtn()
    }
  }
}
</script>
<style lang="stylus">
.content
  width 100%
  height: 100%;
  overflow-x hidden
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch
  position relative
  padding 20px 30px
</style>
